
const initialState = {
  isFetchingAllFormData: false,
  isFinalOrPreliminary: false,
  isFetchingSetOfCompletingForm: false,
  isFetchingHowDisclosuresProvided: false,
  isFetchingDisclosuresProvidedDate: false,
  isFetchingWishToWaiveForFinal: false,
  isFetchingSpouseAgree: false,


  finalOrPreliminary: "-1",
  isSetOfCompletingForm: {
    isSetOfCompletingFormStatus:"-1",
    setOfPropertyForms:{
      setOfPropertyFormsStatus:"-1"
    }
  },

  howDisclosuresProvided:"-1",

  disclosuresProvidedDate:"",

  wishToWaiveForFinal : "-1",

  spouseAgree:{
    spouseAgreeStatus : "-1",
    agreeForFinalDeclaration:{
      agreeForFinalDeclarationStatus : "-1",
    }
  }
};

const acknowledgementReducer = (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_POST_FORM_DATA":
      return { ...state, isFetchingPostFormData: true };
    case "SUCCESS_POST_FORM_DATA":
      return {
        ...state,isFetchingPostFormData: false,
      };
    case "ERROR_POST_FORM_DATA":
      return { ...state, isFetchingPostFormData: false };



    case "REQUEST_PRELIMINARY_FINAL":
      return { ...state, isFinalOrPreliminary: true };

    case "SUCCESS_PRELIMINARY_FINAL":
      return {
        ...state,
        isFinalOrPreliminary: false,
        finalOrPreliminary: action.payload.dividingPropertyDebt,
      };

    case "ERROR_PRELIMINARY_FINAL":
      return { ...state, isFinalOrPreliminary: false };



    case "REQUEST_DISCLOSURE_FORMS":
      return { ...state, isFetchingSetOfCompletingForm: true };
    case "SUCCESS_DISCLOSURE_FORMS":
    
      return {
        ...state,
        isFetchingSetOfCompletingForm: false,
        isSetOfCompletingForm: {
          isSetOfCompletingFormStatus:action.payload.setOfCompletingForm,
          setOfPropertyForms:{
            setOfPropertyFormsStatus:action.payload.propertyType
          }
        },
      };
    case "ERROR_DISCLOSURE_FORMS":
      return { ...state, isFetchingSetOfCompletingForm: false };



    case "REQUEST_DISCLOSURE_PROVIDED":
      return { ...state, isFetchingHowDisclosuresProvided: true };
    case "SUCCESS_DISCLOSURE_PROVIDED":
      return {
        ...state,
        isFetchingHowDisclosuresProvided: false,
        howDisclosuresProvided :action.payload.provideDisclosures
      };
    case "ERROR_DISCLOSURE_PROVIDED":
      return { ...state, isFetchingHowDisclosuresProvided: false };




    case "REQUEST_DATE_DISCLOSURE":
      return { ...state, isFetchingDisclosuresProvidedDate: true };
    case "SUCCESS_DATE_DISCLOSURE":
      
      return {
        ...state,
        isFetchingDisclosuresProvidedDate: false,
        disclosuresProvidedDate: action.payload.dissolutionDate,
      };
    case "ERROR_DATE_DISCLOSURE":
      return { ...state, isFetchingDisclosuresProvidedDate: false };



      case "REQUEST_WAIVE_FINAL_DISCLOSURE":
        return { ...state, isFetchingWishToWaiveForFinal: true };
      case "SUCCESS_WAIVE_FINAL_DISCLOSURE":
        return {
          ...state,
          wishToWaiveForFinal:action.payload.waiveDisclosure,
          isFetchingWishToWaiveForFinal: false,
        };
      case "ERROR_WAIVE_FINAL_DISCLOSURE":
        return { ...state, isFetchingWishToWaiveForFinal: false };



        case "REQUEST_WISH_TO_WAIVE":
          return { ...state, isFetchingSpouseAgree: true };
        case "SUCCESS_WISH_TO_WAIVE":
          return {
            ...state,
            isFetchingSpouseAgree: false,
            spouseAgree:{
              spouseAgreeStatus : action.payload.spouseAgree,
              agreeForFinalDeclaration:{
                agreeForFinalDeclarationStatus : action.payload.waiveFinalDisclosure,
              }
            }
          };
        case "ERROR_WISH_TO_WAIVE":
          return { ...state, isFetchingSpouseAgree: false };


    case "REQUEST_ALL_FORM_DATA":
      return { ...state, isFetchingAllFormData: true };
    case "SUCCESS_ALL_FORM_DATA":
      return {
        ...state,
        isFetchingAllFormData: false,
        finalOrPreliminary: action.payload.data.finalOrPreliminary,
        isSetOfCompletingForm: {
          isSetOfCompletingFormStatus:action.payload.data.isSetOfCompletingForm.isSetOfCompletingFormStatus,
          setOfPropertyForms:{
            setOfPropertyFormsStatus:action.payload.data.isSetOfCompletingForm.setOfPropertyForms.setOfPropertyFormsStatus,
          }
        },
      
        howDisclosuresProvided:action.payload.data.howDisclosuresProvided,
      
        disclosuresProvidedDate: action.payload.data.disclosuresProvidedDate,
      
        wishToWaiveForFinal : action.payload.data.wishToWaiveForFinal,
      
        spouseAgree:{
          spouseAgreeStatus : action.payload.data.spouseAgree.spouseAgreeStatus,
          agreeForFinalDeclaration:{
            agreeForFinalDeclarationStatus : action.payload.data.spouseAgree.agreeForFinalDeclaration.agreeForFinalDeclarationStatus,
          }
        }
       
      };
    case "ERROR_ALL_FORM_DATA":
      return { ...state, isFetchingAllFormData: false };


    default:
      return state;
  }
};
export default acknowledgementReducer;
